import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { getCoinPlan, diasAppPurchase } from "../../store/coinPlan/action";

const DiasAppPurchase = (props) => {
  const [userId, setUserId] = useState("");
  const [errors, setError] = useState({});
  const [coinPlans, setCoinPlans] = useState([]);
  const [selectedCoinPlan, setSelectedCoinPlan] = useState(null);

  useEffect(() => {
    props.getCoinPlan(); // eslint-disable-next-line
  }, []);

  const vipPlan = useSelector((state) => state.coinPlan.coinPlan);

  useEffect(() => {
    setCoinPlans(vipPlan);
    console.log("vipPlan", vipPlan);
  }, [vipPlan]);

  const handleSubmit = () => {
    let formIsValid = true;

    let errors = {};
    if (!userId) {
      formIsValid = false;
      errors["userId"] = "User ID is Required!";
    }
    if (!selectedCoinPlan) {
      formIsValid = false;
      errors["selectedCoinPlan"] = "Diamond Plan is Required!";
    }
    if (!formIsValid) {
      setError(errors);
      return;
    } else {
      const _data = {
        userId: userId,
        planId: selectedCoinPlan,
      };
      props.diasAppPurchase(_data);
      setSelectedCoinPlan(null);
      setUserId("");
      setError({});
    }
  };

  return (
    <div>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Dias App Purchase</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Dias App Purchase
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="modal-body pt-1 px-1 pb-3">
        <div className="d-flex flex-column">
          <form>
            <div className="row align-items-center">
              <div className="col-md-6">
                <label className="text-gray mb-2">User ID</label>
                <input
                  className="form-control"
                  required=""
                  placeholder="00000000"
                  min="0"
                  value={userId}
                  onChange={(e) => {
                    setUserId(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...errors,
                        userId: "User ID is Required!",
                      });
                    } else {
                      return setError({
                        ...errors,
                        userId: "",
                      });
                    }
                  }}
                />
                {errors.userId && (
                  <div className="ml-2 mt-1">
                    {errors.userId && (
                      <div className="pl-1 text__left">
                        <span className="text-red">{errors.userId}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label className="text-gray mb-2">Diamond Plan</label>
                <select
                  className="form-select form-control"
                  aria-label="Diamond Plan selection"
                  value={selectedCoinPlan || ""}
                  onChange={(e) => {
                    setSelectedCoinPlan(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...errors,
                        selectedCoinPlan: "Diamond Plan is Required!",
                      });
                    } else {
                      return setError({
                        ...errors,
                        selectedCoinPlan: "",
                      });
                    }
                  }}
                >
                  <option value="">Select Diamond Plan</option>
                  {coinPlans &&
                    coinPlans.map((plan) => {
                      return (
                        <option key={plan._id} value={plan._id}>
                          {plan.diamonds} (PHP {plan.peso})
                        </option>
                      );
                    })}
                </select>
                {errors.selectedCoinPlan && (
                  <div className="ml-2 mt-1">
                    <div className="pl-1 text__left">
                      <span className="text-red">
                        {errors.selectedCoinPlan}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className={"mt-5"}>
              <button
                type="button"
                className="btn btn-round float__right btn-danger"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { getCoinPlan, diasAppPurchase })(DiasAppPurchase);
